import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const FileMinusIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill={theme.colors.primary.variant8}
        viewBox="0 0 16 16"
      >
        <path d="M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z" />
        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
      </svg>
    </Icon>
  );
};

export default FileMinusIcon;
